import script from "./MeChangeCom.vue?vue&type=script&setup=true&lang=js"
export * from "./MeChangeCom.vue?vue&type=script&setup=true&lang=js"

import "./MeChangeCom.vue?vue&type=style&index=0&id=44d68c38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44d68c38"]])

export default __exports__